import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import StolenReport from "../components/StolenReport";

export default function ReportStolen() {
  return (
    <div className="min-h-screen flex flex-col font-sans bg-gray-50">
      {/* Page Header Banner */}
      <header className="bg-slate-900 pt-12 pb-20 border-b-4 border-yellow-400">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-yellow-400 hover:text-yellow-300 mb-6 font-medium transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </Link>
          <h1 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight">
            Stolen Vehicle Report Portal
          </h1>
          <p className="mt-4 text-lg text-gray-300 max-w-2xl">
            Register and file a secure report to aid the recovery of your vehicle.
          </p>
        </div>
      </header>

      {/* Main Form/Instruction Area */}
      <main className="flex-grow max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 -mt-10 mb-16 relative z-10">
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-10">
          <StolenReport />
        </div>
      </main>

      <Footer />
    </div>
  );}